import React, { forwardRef, useRef, useImperativeHandle } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";
import { getImagePath } from "../../utilities/path";
import { AutomationTestIdFeature, AutomationTestIdElementType, createDataTestId } from "../../utilities/automation";
import { usePageProps } from '../../context/PagePropContext';
import { VISIBLE_COMPONENTS_NAMES } from '../../context/VisibleComponentsContext';
import { useOnScreen } from '../Hooks/useOnScreen';
import Picture from "../Picture";

export interface IHeroProps extends IEditableProps, IStyledProps {
    src: string;
    alt: string;
    underhang?: boolean;
    children;
}

const Hero = forwardRef((props: IHeroProps, ref: any) => {
    const { children, editorClassObj, className, cmsId } = props;
    const { path } = usePageProps()
    const isMustReads = path && (path.indexOf('must-reads') === 0 || path.indexOf('/must-reads') === 0);
    const mustReadsClassObj = { 'must-reads': isMustReads }

    const innerRef = useRef<HTMLInputElement>(null);

    useOnScreen(innerRef, VISIBLE_COMPONENTS_NAMES.HERO);
    useImperativeHandle(ref, () => innerRef.current!, []); // Passes innerRef to forwardRef's ref so that we can use innerRef in custom hook


    const overlay = React.Children.map(children, child => {
        if (typeof child === "object") {
            return React.cloneElement(child, { className: classNames(child.className, "h-100 py-lg-6 px-xl-6 px-lg-5 px-4 py-5"), type: "header1" })
        }
    });

    return (
        <div data-id={cmsId} ref={innerRef} className={classNames(className, editorClassObj, "position-relative", "hero-overlay", mustReadsClassObj)}>
            <Picture
                src={getImagePath(props.src)}
                alt={props.alt}
                dataTestId={createDataTestId({feature: AutomationTestIdFeature.HERO, element: AutomationTestIdElementType.IMAGE, specifier: 'hero-bg'})}
            />
            <div className="container h-100 p-0">
                <div className="col-xl-6 col-lg-8 col-12 h-100 p-0">
                    {overlay}
                </div>
            </div>
        </div>
    )
});

export default styled(Hero)`
   width: 100%;
   padding: ${props => props.underhang ? "3.5rem 0" : "1.5rem 0 3.5rem 0"};
   margin-top: ${props => props.underhang ? "-2rem" : "0"};
   overflow: hidden;
   min-height: 580px;

   .overlay {
      min-height: 500px;

      .card-title {
         margin-bottom: 1.5rem;
      }
   }

   img {
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;
      object-fit: cover;
   }

   &.must-reads {
        min-height: 380px;

        .overlay {
            min-height: 300px;
        }
    }
`;